import { PLATFORM } from '@/config/platform';
interface DownloadTemplatePanelProps {
  channel: 'wallet' | 'mobile';
  onDownload: (format: 'excel' | 'csv') => void;
}

const templateColumns: Record<'wallet' | 'mobile', string[]> = {
  wallet: ['name', 'wallet_id', 'wallet_type', 'amount', 'description', 'payment_date'],
  mobile: ['name', 'mobile_number', 'network', 'amount', 'description', 'payment_date'],
};

export function DownloadTemplatePanel({ channel, onDownload }: DownloadTemplatePanelProps) {
  const columns = templateColumns[channel];
  const channelLabel = channel === 'mobile' ? 'Mobile Money' : `${PLATFORM.walletName}s`;

  return (
    <section className="rounded-lg border border-background-200 bg-background-100">
      <header className="flex items-center gap-2 border-b border-background-200 px-5 py-4">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-base text-accent-700">
          <i className="ri-download-2-line" />
        </span>
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950">Download Template</h3>
          <p className="mt-0.5 text-xs text-foreground-500">
            Columns tuned for {channelLabel} — switches with your Transaction Type.
          </p>
        </div>
      </header>
      <div className="space-y-3 px-5 py-4">
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onDownload('excel')}
            className="inline-flex items-center gap-1.5 rounded-md border border-accent-300 bg-accent-50 px-3 py-1.5 text-xs font-label font-medium text-accent-800 cursor-pointer transition-colors hover:bg-accent-100"
          >
            <i className="ri-file-excel-2-line" />
            Excel
          </button>
          <button
            type="button"
            onClick={() => onDownload('csv')}
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-label font-medium text-foreground-700 cursor-pointer transition-colors hover:bg-background-100"
          >
            <i className="ri-file-text-line" />
            CSV
          </button>
        </div>
        <div>
          <p className="text-[11px] font-label uppercase tracking-wide text-foreground-500">
            Included columns
          </p>
          <div className="mt-1.5 flex flex-wrap gap-1.5">
            {columns.map((column) => (
              <span
                key={column}
                className="rounded border border-background-300 bg-background-50 px-2 py-0.5 text-[11px] font-label text-foreground-600"
              >
                {column}
              </span>
            ))}
          </div>
        </div>
        <p className="inline-flex items-start gap-1.5 rounded-md bg-background-50 px-2.5 py-2 text-[11px] leading-relaxed text-foreground-600">
          <i className="ri-time-line mt-0.5 text-secondary-700" />
          <span>
            <span className="font-label font-medium text-foreground-800">payment_date</span> is
            optional — add it as <span className="font-label">YYYY-MM-DD HH:MM</span> to release a
            row on a specific day and time. Leave it blank to pay immediately or use the batch
            schedule.
          </span>
        </p>
      </div>
    </section>
  );
}